<template>
    <router-link :to="{ name: item.route }">
        <v-list-tile
            @click="navigate(item)"
        >
            <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title>
                    {{ item.text }}
                </v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
    </router-link>
</template>

<script>
export default {
    components: {
        
    },
    props: [
        "item"
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        navigate(item) {
            this.$router.push({ name: item.route });

            this.$store.commit("generalStore/hideNavDrawer");
        }
    }
};
</script>

<style>

</style>
